"use client";

import { BagTotals, formatUsd } from "@/lib/comix/bagConfig";
import PrimaryButton from "@/components/shared/PrimaryButton";
import { trackEvent } from "@/lib/amplitude";
import type { ReactNode } from "react";
import WalletTextLinks from "@/components/comix/wallet/WalletTextLinks"; // wallet-express-pay

export default function BagSummary({
  totals,
  checkoutUrl,
  onCheckout,
  onCreateAnother,
  isSyncing,
  walletSlot,
  walletVisible,
  walletLocked,
}: {
  totals: BagTotals;
  checkoutUrl: string;
  onCheckout: () => void;
  onCreateAnother: () => void;
  isSyncing?: boolean;
  // wallet-express-pay: Apple/Google Pay for the whole bag (renders nothing unless enabled)
  walletSlot?: ReactNode;
  walletVisible?: boolean;
  walletLocked?: boolean;
}) {
  return (
    <div className="border-t border-[#ececec] px-5 pb-5 pt-4">
      <div className="flex items-center justify-between text-[16px]">
        <span className="font-medium text-[#333]">Total</span>
        {isSyncing ? (
          <div className="h-5 w-16 animate-pulse rounded bg-[#e0e0e0]" />
        ) : (
          <span className="font-semibold text-[#333]">
            {totals.discountActive ? (
              <>
                <span className="mr-1 font-normal text-[#828282] line-through">
                  {formatUsd(totals.totalBeforeDiscount)}
                </span>
                {formatUsd(totals.total)}
              </>
            ) : (
              formatUsd(totals.total)
            )}
          </span>
        )}
      </div>
      <p className="mb-1 text-[13px] text-[#828282]">
        Shipping calculated at checkout
      </p>

      {walletSlot /* wallet-express-pay: Apple/Google Pay big button, only when detected */}
      {/* Checkout is always a big button in the bag (under Apple Pay when it shows). */}
      <PrimaryButton
        id="btn-bag-checkout"
        href={checkoutUrl}
        onClick={onCheckout}
        disabled={walletLocked}
        className={`${walletVisible ? "mt-3" : "mt-4"} block w-full`}
      >
        Checkout
      </PrimaryButton>
      <WalletTextLinks
        className="mt-4"
        links={[
          {
            id: "btn-bag-create-another",
            label: "Create another book",
            href: "/comix/stories",
            onClick: () => {
              trackEvent("Bag - Create Another Clicked", { total: totals.total });
              onCreateAnother();
            },
          },
        ]}
      />
    </div>
  );
}
